import { updateDataNode } from '@/endpoints'
import { StructureDetailDto,StructureObjectDto } from '@/endpoints/models'
import { apiCallAction, UpdateDeepPartial } from '@/store/utils'
import { AppDispatch } from '@/store/utils'
import { InitDataParams } from '@/utils/structureType/useStructureTypeActions'

import { loadNodeOrHistoryVersion } from '../node/utils'
import {
	WORKFLOW_INIT,
	WORKFLOW_SAVE,
	WORKFLOW_SELECT_TAB,
	WORKFLOW_UPDATE,
	WORKFLOW_UPDATE_GRAPH,
} from './constants'
import { UserGraphData,WorkflowDataForm, WorkflowTab } from './types'

interface InitWorkflow {
	editMode: boolean,
	force: boolean,
	node: StructureDetailDto,
	type: typeof WORKFLOW_INIT
}

interface SaveWorkflow {
	metadata: {
		node: StructureObjectDto
	},
	payload: void
	type: typeof WORKFLOW_SAVE
}

interface UpdateWorkflow {
	node: StructureObjectDto,
	type: typeof WORKFLOW_UPDATE,
	update: Partial<WorkflowDataForm>
}

interface WorkflowSelectTab {
	node: StructureObjectDto,
	tab: WorkflowTab,
	type: typeof WORKFLOW_SELECT_TAB
}

interface WorkflowUpdateGraph {
	node: StructureObjectDto,
	type: typeof WORKFLOW_UPDATE_GRAPH,
	update: UpdateDeepPartial<UserGraphData>
}

export const initWorkflow =
	({
		nodeId,
		editMode = false,
		force = false,
		version,
		envId,
	}: InitDataParams) =>
	async (dispatch: AppDispatch) => {
		const node = await loadNodeOrHistoryVersion(nodeId, version, envId)

		dispatch({
			type: WORKFLOW_INIT,
			node,
			editMode,
			force,
		} as InitWorkflow)
	}

export const updateWorkflow = (
	node: StructureObjectDto,
	update: Partial<WorkflowDataForm>,
): Actions => ({
	type: WORKFLOW_UPDATE,
	node,
	update,
})

export const saveWorkflow = (node: StructureObjectDto) =>
	apiCallAction(
		(getState) => {
			const workflow = getState().workflow.workflows[node.id]

			if (!workflow) {
				throw new Error(`Saving unopened state ${JSON.stringify(node)}`)
			}

			return updateDataNode(node.id, {
				data: JSON.stringify(workflow.form),
			})
		},
		WORKFLOW_SAVE,
		{ node },
	)

export const selectWorkflowTab = (
	node: StructureObjectDto,
	tab: WorkflowTab,
): Actions => ({
	type: WORKFLOW_SELECT_TAB,
	node,
	tab,
})

export const updateWorkflowGraphData = (
	node: StructureObjectDto,
	update: UpdateDeepPartial<UserGraphData>,
): Actions => ({
	type: WORKFLOW_UPDATE_GRAPH,
	node,
	update,
})

export type Actions =
	| InitWorkflow
	| SaveWorkflow
	| UpdateWorkflow
	| WorkflowSelectTab
	| WorkflowUpdateGraph
